const rawItems = [
	{
		key: "searchResultOnline",
		value: "active",
		meta: {
			// Url z poprzedniej w wersji DZ dla zachowania zgodności linków
			url: "all",
		},
	},
	{
		key: "searchResultLatest",
		value: "added",
		meta: {
			// Url z poprzedniej w wersji DZ dla zachowania zgodności linków
			url: "newest",
		},
	},
	{
		key: "searchResultPopular",
		value: "popular",
		meta: {
			// Url z poprzedniej w wersji DZ dla zachowania zgodności linków
			url: "popular",
		},
	},
];

export { rawItems };

export const isValid = (value) => {
	const validValuesArray = rawItems.map((item) => item.meta.url);
	return validValuesArray.includes(value);
};

export const compute = {
	valueToUrl: (value) => {
		const current = rawItems.find((item) => item.value === value);
		return current ? current.meta.url : "";
	},
	urlToApiParam: (value) => {
		if (!value) return null;
		const current = rawItems.find(({ meta: { url } }) => url === value);
		return current?.value;
	},
};

const useFilterSort = () => {
	return {
		items: [...rawItems],
		compute,
		isValid,
	};
};

export default useFilterSort;
